import { Suspense, forwardRef, lazy } from "react";

const loadable = (importFunc, { fallback = null } = { fallback: null }) => {
  const LazyComponent = lazy(() => {
    return importFunc().then(({ default: Component }) => {
      return {
        default: forwardRef((props, ref) => <Component {...props} ref={ref} />),
      };
    });
  });
  return forwardRef((props, ref) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} ref={ref} />
    </Suspense>
  ));
};

export default loadable;
